var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyShop = function SvgEmptyShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 126,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2360_24110)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "#F5F4EE",
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M94 23v22m11-11H83"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BF1424",
    strokeLinecap: "round",
    strokeWidth: 6.6,
    d: "m86.5 87.5.813-5.832c.212-3.773-2.637-7.09-6.527-7.6l-7.925-1.037M40 119.5l-6.498-.794c-4.303-.564-7.242-4.524-6.394-8.616l7.323-35.348c.766-3.7 4.374-6.171 8.264-5.662l7.924 1.038m0 0 .935-7.139c.775-5.914 6.382-10.056 12.524-9.252 6.142.805 10.493 6.251 9.718 12.165l-.935 7.139M50.62 70.118l22.242 2.913m11.168 36.061a8.048 8.048 0 0 1-15.958-2.09m-11.113 22.891 31.915 4.18a8.047 8.047 0 0 0 9.023-6.934l2.613-19.947a8.047 8.047 0 0 0-6.934-9.023l-31.915-4.18a8.047 8.047 0 0 0-9.024 6.934l-2.612 19.946a8.047 8.047 0 0 0 6.934 9.024Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2360_24110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "#fff",
    rx: 20
  })))));
};
export default SvgEmptyShop;